export const pollColorPalette = {
  rankingScale: {
    hue: 210,
    saturation: 82,
    startLightness: 32,
    endLightness: 78,
  },
  lowRankScale: {
    hue: 142,
    saturation: 58,
    startLightness: 28,
    endLightness: 74,
  },
  averageIndicator: "hsl(0deg 80% 68%)",
  lowRankOverflow: "hsl(142deg 72% 41%)",
  unrankedOverflow: "hsl(45deg 93% 58% / 60%)",
};
